var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MPButton',{staticClass:"a-button",attrs:{"color":"white","size":"large"},on:{"click":_vm.handleClick}},[_c('div',{staticClass:"button-content"},[_c('img',{staticClass:"icon",attrs:{"src":require('@/assets/icons/apple.svg')}}),_c('span',{staticClass:"text"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }